// Bouton des e-mails à code (app/core/email.py::code_link) : la page s'ouvre avec
// `#mail=…&code=…`, l'adresse et le code déjà saisis.
//
// Le fragment ne quitte jamais le navigateur ; on l'efface de l'adresse dès la
// lecture pour qu'il ne reste pas dans l'historique.

const CODE_PATTERN = /^\d{6}$/;

// Lu une fois, au montage (initialiseur de useState) : { mail, code }, chacun
// vide s'il manque. Un ancien lien d'activation ne portait que `#mail=`.
export function readEmailCodeLink() {
  try {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const code = params.get('code') || '';
    return { mail: (params.get('mail') || '').trim(), code: CODE_PATTERN.test(code) ? code : '' };
  } catch (_) {
    return { mail: '', code: '' };
  }
}

export function clearEmailCodeLink() {
  if (window.location.hash) {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  }
}

// Une page ouverte depuis l'e-mail ne valide le code d'elle-même que si CE
// navigateur l'a demandé récemment. Les antivirus de messagerie qui ouvrent les
// liens et exécutent la page le consommeraient sinon avant la personne ; chez
// eux, le code est seulement pré-rempli et attend un appui sur « Valider ».
// Aucune adresse n'est stockée : seulement l'heure de la demande.
const REQUESTED_AT_KEY = 'code_requested_at';
const REQUEST_TTL_MS = 24 * 60 * 60 * 1000; // code le plus long : activation coach, 24 h

export function rememberCodeRequest() {
  try {
    localStorage.setItem(REQUESTED_AT_KEY, String(Date.now()));
  } catch (_) {
    // Stockage indisponible : le code sera pré-rempli, à valider d'un appui.
  }
}

export function codeRequestedHere() {
  try {
    const at = Number(localStorage.getItem(REQUESTED_AT_KEY));
    return at > 0 && Date.now() - at < REQUEST_TTL_MS;
  } catch (_) {
    return false;
  }
}
